// Module
var code = "<span class=\"badge\" :class=\"classes\">\n  <icon v-if=\"iconName\" :name=\"iconName\"></icon>\n  <span class=\"badge-text\">{{ text }}</span>\n</span>\n";
// Exports
export default code;